export default "__VITE_ASSET__i7B98WiD__"